var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.565,
    height: 27.583,
    viewBox: "0 0 49.565 27.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    "data-name": "Rectangle 1440",
    width: 49.565,
    height: 27.583,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48461",
    "data-name": "Path 48461",
    d: "M8.86,9.549a2.868,2.868,0,0,1-.917-2.892c.33-2.039,2.147-3.6,6.327-3.615s6.585,1.6,6.839,3.107.077,3.234-1.527,3.4-10.722,0-10.722,0",
    transform: "translate(10.994 4.241)",
    fill: "#4cbd01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48462",
    "data-name": "Path 48462",
    d: "M41.721,13.323a7.092,7.092,0,0,0-3.861,1.142l-.053.034L35.729,12.15l.869-.768a.658.658,0,0,0,.055-.926l-.5-.563h1.271a.657.657,0,0,0,.656-.658V4.212a.657.657,0,0,0-.656-.656h-1.6a3.174,3.174,0,0,0-3.057,2.339l-.036.132-.682-.771a.654.654,0,0,0-.926-.057l-.493.436L29.838,1.39A1.552,1.552,0,0,0,28.254,0h-2.8a.657.657,0,0,0,0,1.314h2.8a.237.237,0,0,1,.278.227c.012.081.627,3.349.948,5.065l.01.041-.721.639-.041-.017a11.03,11.03,0,0,0-3.813-.651c-3.72,0-6.829,1.695-7.394,4.029l-.014.065-.065-.007c-2.707-.3-3.662-1.36-5.245-3.117l-.218-.242a.655.655,0,0,0-.488-.218.665.665,0,0,0-.412.146,5.782,5.782,0,0,0-2.111,3.382l-.014.074-.074-.019A10.034,10.034,0,0,0,.8,12.123a.657.657,0,0,0,.369,1.2.673.673,0,0,0,.366-.113A8.734,8.734,0,0,1,14.8,22.919a.661.661,0,0,0,.445.816.69.69,0,0,0,.187.026H27.476a.655.655,0,0,0,.622-.452l3.035-9.2.012-.012a4.334,4.334,0,0,0,.912-1.226l.048-.1.847.958a.654.654,0,0,0,.926.057l.867-.768,2.035,2.3-.05.048a7.126,7.126,0,1,0,4.991-2.044M35.827,4.868h.943v3.71h-.943a1.855,1.855,0,1,1,0-3.71m-22.607,8.2a10.044,10.044,0,0,0-2.956-1.9l-.053-.022.007-.057A4.311,4.311,0,0,1,11.389,8.77l.055-.057.053.057c1.594,1.762,2.87,2.94,5.937,3.253l.053,0,.012.053a3.448,3.448,0,0,0,.326.9l.057.108H13.242ZM27,22.448H16.263l.017-.086a10.044,10.044,0,0,0,.184-1.908,10.178,10.178,0,0,0-.189-1.939l-.017-.086h3.119a.657.657,0,0,0,0-1.314H15.892l-.017-.048a10.088,10.088,0,0,0-1.36-2.549L14.43,14.4H29.654Zm3.323-9.381-.022.022H19.526l-.022-.022a2.392,2.392,0,0,1-.764-1.649c0-1.891,2.827-3.485,6.174-3.485s6.171,1.594,6.171,3.485a2.392,2.392,0,0,1-.764,1.649m3.179-.7L32.38,11.1l0-.024a4.326,4.326,0,0,0-2.243-3.126L30.054,7.9,31.5,6.615l3.732,4.218Zm8.22,13.9a5.817,5.817,0,1,1,5.817-5.817,5.823,5.823,0,0,1-5.817,5.817",
    transform: "translate(0.713 -0.001)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48463",
    "data-name": "Path 48463",
    d: "M19.852,7.019a3.652,3.652,0,1,0,3.651,3.65,3.654,3.654,0,0,0-3.651-3.65m0,5.989a2.339,2.339,0,1,1,2.339-2.339,2.341,2.341,0,0,1-2.339,2.339",
    transform: "translate(22.582 9.783)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48464",
    "data-name": "Path 48464",
    d: "M7.131,5.565A7.13,7.13,0,1,0,14.262,12.7,7.14,7.14,0,0,0,7.131,5.565m0,12.948A5.817,5.817,0,1,1,12.948,12.7a5.823,5.823,0,0,1-5.817,5.817",
    transform: "translate(0 7.756)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48465",
    "data-name": "Path 48465",
    d: "M5.1,7.019a3.652,3.652,0,1,0,3.65,3.65A3.654,3.654,0,0,0,5.1,7.019m0,5.989a2.339,2.339,0,1,1,2.339-2.339A2.34,2.34,0,0,1,5.1,13.008",
    transform: "translate(2.027 9.783)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48466",
    "data-name": "Path 48466",
    d: "M9.991,10.476a.657.657,0,0,0,.656-.656V7.807a.656.656,0,1,0-1.312,0V9.82a.657.657,0,0,0,.656.656",
    transform: "translate(13.011 9.964)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48467",
    "data-name": "Path 48467",
    d: "M11.21,10.476a.657.657,0,0,0,.656-.656V7.807a.656.656,0,1,0-1.312,0V9.82a.657.657,0,0,0,.656.656",
    transform: "translate(14.71 9.964)",
    fill: "#3d3d3d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyBike);
export default __webpack_public_path__ + "static/media/policy-bike.0403ddf17b02870631f8c3c710080cf6.svg";
export { ForwardRef as ReactComponent };